export const routeName = 'partner-ngos';
export const slugs: Record<string, string> = {
	es: 'ong-colaboradoras',
	en: 'partner-ngos',
	ca: 'ong-collaboradores',
	fr: 'ong-partenaires',
	it: 'ong-partner',
};
// No `sitemap` while the page is a placeholder: that field is what puts a route in the sitemap, and
// a "coming soon" body has no business being submitted for indexing. Add it when the page lands.
